import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
const TotalLabel = (param)=>{
    let { label , value , bold , className , ...props } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex justify-between items-center", className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "body1",
                as: "span",
                className: "text-secondary",
                children: label
            }),
            /*#__PURE__*/ _jsx(Typography, {
                className: cn(bold ? "typo-subtitle1 text-title" : "typo-body1 text-secondary"),
                as: "span",
                children: value
            })
        ]
    });
};
export default TotalLabel;
